module.exports = __webpack_public_path__ + "static/media/main3.84254dca.svg";